import React, { useEffect } from "react";
import { FDialog, FGrid } from "ferrum-design-system";
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";
import CIRCLE from "../../../../assets/ms-new-images/icons/circleIcon.png";
import fiberEngineIcon from "../../../../assets/ms-new-images/icons/ms-fiber-engine-icon.png";
import mobileLoading from "../../../../assets/gif/mobileloading.gif";
import loadingfinish from "../../../../assets/gif/loading-finish.gif";
import vector from "../../../../assets/img/vector.png";
import nodeVerification from "../../../../assets/gif/nodeVerification.gif";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducer";

export const MobileQuoteAndFiberProgressBarDialog = ({
  show,
  setShow,
  progressBar,
  destinationMobileProgressBar,
  swapProgressBar,
}: any) => {
  const {
    fromInfo,
    toInfo,
    isSwappingScreenBlocked,
    sourceTokenCategorizedInfo,
    destinationTokenCategorizedInfo,
  } = useSelector((state: RootState) => state.swap);

  const onclose = () => {
    setShow(false);
  };

  return (
    <div className="full-screen-mobile">
      <FDialog
        show={show}
        onHide={() => onclose()}
        size={"large"}
        variant={"new-popup"}
        showClose={true}
      >
        <div className="full-screen-center">
          {!isSwappingScreenBlocked && (
            <FGrid className="fiber-engine-mobile">
              <div className="mobile-view">
                <div className="">
                  <img src={fiberEngineIcon} alt="fiberEngineIcon" />
                  <div
                    className="d-flex ai ai-center jc jc-center"
                    style={{ color: progressBar ? "white" : "gray" }}
                  >
                    <img
                      style={{
                        filter: `grayscale(${progressBar ? 0 : 100}%)`,
                      }}
                      width={20}
                      height={20}
                      src={progressBar > 0 ? loadingfinish : CIRCLE}
                    />
                    <span>Checking Networks</span>
                  </div>
                  <div
                    className="d-flex ai ai-center jc jc-center"
                    style={{ color: progressBar ? "white" : "gray" }}
                  >
                    <img
                      style={{
                        filter: `grayscale(${progressBar ? 0 : 100}%)`,
                      }}
                      width={20}
                      height={20}
                      src={progressBar > 20 ? loadingfinish : mobileLoading}
                    />
                    <span>Categorization</span>
                  </div>
                  <div
                    className="d-flex ai ai-center jc jc-center"
                    style={{
                      color: destinationMobileProgressBar ? "white" : "gray",
                    }}
                  >
                    <img
                      style={{
                        filter: `grayscale(${
                          destinationMobileProgressBar ? 0 : 100
                        }%)`,
                      }}
                      width={20}
                      height={20}
                      src={progressBar > 40 ? loadingfinish : mobileLoading}
                    />
                    <span>Source Network</span>
                  </div>
                  <div
                    className="d-flex ai ai-center jc jc-center"
                    style={{
                      color: destinationMobileProgressBar ? "white" : "gray",
                    }}
                  >
                    <img
                      style={{
                        filter: `grayscale(${
                          destinationMobileProgressBar ? 0 : 100
                        }%)`,
                      }}
                      width={20}
                      height={20}
                      src={progressBar > 60 ? loadingfinish : mobileLoading}
                    />
                    <span>Destination Networks</span>
                  </div>
                  <div className="foundry-assets">
                    {progressBar > 40 && (
                      <div
                        style={{
                          color: progressBar > 40 ? "white" : "",
                        }}
                      >
                        {sourceTokenCategorizedInfo?.type} Assets{" "}
                        <img
                          className="progressbar-fiber-img"
                          src={fromInfo?.network?.logo}
                          width={20}
                          height={20}
                        />
                      </div>
                    )}
                    <p style={{ color: "grey" }}>Source Network</p>
                    <div className="f-pt-1">
                      <img src={vector} alt="vector" width={20} height={20} />
                    </div>
                    {progressBar > 60 && (
                      <div
                        style={{
                          color: progressBar > 60 ? "white" : "",
                        }}
                      >
                        {destinationTokenCategorizedInfo?.type} Assets{" "}
                        <img
                          className="progressbar-fiber-img"
                          src={toInfo?.network?.logo}
                          width={20}
                          height={20}
                        />
                      </div>
                    )}
                    <p style={{ color: "grey" }}>Destination Network</p>
                  </div>
                  {/* <>
                    {progressBar > 60 && (
                      <div className="mobileprogressbar">
                        <ProgressBar
                          width={230}
                          height={3}
                          percent={100}
                          filledBackground="linear-gradient(to right, #feb72,#D9B373)"
                        ></ProgressBar>
                      </div>
                    )}
                  </> */}
                </div>
              </div>
            </FGrid>
          )}

          {isSwappingScreenBlocked && (
            <FGrid className="fiber-engine-mobile">
              <div className="mobile-view">
                <img src={fiberEngineIcon} alt="fiberEngineIcon" />
              </div>
              <div style={{ color: progressBar ? "white" : "gray" }}>
                <img
                  style={{
                    filter: `grayscale(${swapProgressBar ? 0 : 100}%)`,
                  }}
                  width={20}
                  height={20}
                  src={progressBar > 0 ? loadingfinish : CIRCLE}
                />
                Fiber Manager{" "}
                <img
                  className="progressbar-fiber-img"
                  src={fromInfo?.network.logo}
                  width={20}
                  height={20}
                />
              </div>
              <div style={{ color: swapProgressBar ? "white" : "gray" }}>
                <img
                  style={{
                    filter: `grayscale(${swapProgressBar ? 0 : 100}%)`,
                  }}
                  width={20}
                  height={20}
                  src={swapProgressBar > 0 ? loadingfinish : mobileLoading}
                />
                Fiber Manger{" "}
                <img
                  className="progressbar-fiber-img"
                  src={fromInfo?.network.logo}
                  width={20}
                  height={20}
                />
              </div>
              <div
                style={{
                  color: destinationMobileProgressBar ? "white" : "gray",
                }}
              >
                <img
                  style={{
                    filter: `grayscale(${swapProgressBar ? 0 : 100}%)`,
                  }}
                />
                <img src={nodeVerification} alt="" width={280} />
              </div>
              <div
                style={{
                  color: swapProgressBar ? "white" : "gray",
                }}
              >
                <img
                  style={{
                    filter: `grayscale(${swapProgressBar ? 0 : 100}%)`,
                  }}
                  width={20}
                  height={20}
                  src={swapProgressBar > 60 ? loadingfinish : mobileLoading}
                />
                Fiber Router{" "}
                <img
                  className="progressbar-fiber-img"
                  src={toInfo?.network.logo}
                  width={20}
                  height={20}
                />
              </div>
              <div>
                <div style={{ color: swapProgressBar ? "white" : "gray" }}>
                  <img
                    style={{
                      filter: `grayscale(${swapProgressBar ? 0 : 100}%)`,
                    }}
                    width={20}
                    height={20}
                    src={swapProgressBar > 60 ? loadingfinish : mobileLoading}
                  />
                  Fiber Manager{" "}
                  <img
                    className="progressbar-fiber-img"
                    src={toInfo?.network.logo}
                    width={20}
                    height={20}
                  />
                </div>
                <div style={{ color: swapProgressBar ? "white" : "gray" }}>
                  <img
                    style={{
                      filter: `grayscale(${swapProgressBar ? 0 : 100}%)`,
                    }}
                    width={20}
                    height={20}
                    src={swapProgressBar > 90 ? loadingfinish : mobileLoading}
                  />
                  Destination Network
                </div>
              </div>
            </FGrid>
          )}
        </div>
      </FDialog>
    </div>
  );
};
